//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SwoopForm from '@/components/SwoopForm'
import Button from '@/components/Button'
import Header from './header'
import Response from './Response'
import { getRelativeDate } from '@/utils/swoop'
import Creator from './Creator'
import Wizard from './Wizard'

import { convertTicketFields } from './fieldConverter'

import GQL from './gql'
import NewResponse from '@/views/support/NewResponse'
import SkeletonResponse from '@/views/support/SkeletonResponse'

export default {
  name: 'Ticket',

  props: {
    ticket_id: null
  },

  components: {
    SkeletonResponse,
    NewResponse,
    Header,
    Button,
    SwoopForm,
    Response,
    Creator,
    Wizard
  },

  data() {
    return {
      form: null, // SwoopForm api object
      newResponse: false,
      savingResponse: false,
      ticket: null,
      tickets: [],
      fields: [],
      echoConnected: false
    }
  },

  created() {
    this.getTicket()
  },

  watch: {
    ticketID() {
      this.getTicket()
    }
  },

  computed: {
    ticketResponsesOrdered() {
      if (
        'responses' in this.ticket &&
        typeof this.ticket.responses !== 'undefined'
      ) {
        let responses = this.ticket.responses
        return responses.reverse()
      }

      return []
    },
    ticketID() {
      if (this.ticket_id == null) {
        return this.$route.params.id // Current site id
      }
      return this.ticket_id
    },
    isCreating() {
      return this.$route.path === '/support/new'
    },
    dateCreated() {
      return getRelativeDate(this.ticket.created_at, true)
    }
  },

  methods: {
    newResponseAdded(responses) {
      this.newResponse = !this.newResponse
      this.ticket.responses = responses
      this.savingResponse = false
    },
    getTicket() {
      if (!this.ticketID) {
        this.ticket = null
      } else {
        GQL.ticket(this.ticketID).then(data => {
          this.fields = convertTicketFields(
            data.workflow_fields.fields,
            data.ticket_data,
            true
          )
          this.ticket = data
          if (this.form) {
            // If form is already rendered, loads the new record into the rendered form,
            // allowing it to correctly track further changes.
            this.form.load(this.ticket)
          }
        })
      }
    }
  }

  // this stuff is for the real time notifications. but we need a way to authenticate people to channels... whoops missed that
  /*mounted() {
    // Listen for the 'NewBlogPost' event in the 'team.1' private channel
    if (this.ticketID != null) {
      this.$echo
        .channel('ticket.' + this.ticketID)
        .listen('TicketResponseCreated', payload => {
           console.log('New ticket response created')
        })
      this.echoConnected = true
    }
  },

  beforeDestroy() {
    if (this.echoConnected) {
      this.$echo.leave('ticket.' + this.ticketID)
    }
  }*/
}
